module.exports = __webpack_public_path__ + "static/media/podcast-hero-mobile.d8d2b614.svg";